import GoogleMap from './gmaps';
import './logos';

/**
 * Activate smooth scroll
 */

/**
 * Google maps
 */
const maps = document.querySelectorAll('.acf-map');

Array.from(maps).forEach((map) => {
    const markers = map.querySelectorAll('.marker');
    const gmap = new GoogleMap(map);

    Array.from(markers).forEach((marker) => {
        gmap.addMarker(marker);
    });

    gmap.centerMap();
});

/**
 * Add anchor link tracking
 */
const links = document.querySelectorAll('a[href*="#"]');

Array.from(links).forEach((element) => {
    let href = element.getAttribute('href');

    // Clean up URL
    if (href.indexOf('#') !== false) {
        href = href.substr(href.indexOf('#'));
    }

    if (href.length > 2) {
        element.addEventListener('click', (e) => {
            // Make sure the anchor is on the current page
            if (location.pathname.replace(/^\//, '') === element.pathname.replace(/^\//, '')
                && location.hostname === element.hostname) {
                e.preventDefault();
                scroll.to(href);
            }
        });
    }
});

/**
 * Check URL for hash
 */
window.addEventListener('load', () => {
    if (window.location.hash) {
        scroll.to(window.location.hash);
    }
});

/**
 * Mobile Nav
 */
const mobileNavToggle = document.querySelector('.menu-trigger');
const mobileNav = document.querySelector('.mobile');

if (mobileNavToggle) {
    mobileNavToggle.addEventListener('click', (e) => {
        e.preventDefault();
        mobileNav.classList.toggle('is-open');
    });
}

/**
 * Google Analytics
 */
jQuery(document).ready(function ($) {
    $(document).on('frmFormComplete', function (event, form, response) {
        if ($(form).find('input[name="form_id"]').val() == 3) {
            gtag('send', 'event', 'business', 'sent');
        }
    });
});
